import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from "./Grid";
import Header from "./header";
import Footer from "./footer";
import Insert from "./insert";
import * as CashTeller from './Saga/CashTellers';
import moment from 'moment';
import './Css/CashTeller.css';


import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
interface Props {

    user_details: any,
    cash_tellers_list: any,
    cash_tellers_contentslist: any,
    get_contentslist: any,
    get_list: any,
    get_cash_teller_nowmonthly: any,
    cash_teller_nowmonthly: any
}



interface State {
    refresh: boolean,
    SelectSection: Number,
    selectedDate: string,
    in: number,
    out: number
}

class Cashteller extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            refresh: false,
            SelectSection: 0,
            selectedDate: moment(new Date()).format("YYYY-MM"),
            in: 0,
            out: 0
        }

        props.get_contentslist();
        this.SectionSave = this.SectionSave.bind(this);
        this.DateSave = this.DateSave.bind(this);
        this.GetList = this.GetList.bind(this);
        this.In = this.In.bind(this);
        this.Out = this.Out.bind(this);
        this.Reset = this.Reset.bind(this);
    }

    componentWillMount() {

    }

    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        console.log(this.state.refresh);

        return
    }

    SectionSave = (e: any) => {
        this.setState({
            SelectSection: e,
        });
    }

    DateSave = (e: any) => {
        this.setState({
            selectedDate: e,
        });
    }

    GetList() {
        console.log("Ver1.04")
        this.setState({
            in: 0,
            out: 0
        });
        var data = {
            section: this.state.SelectSection,
            date: this.state.selectedDate,
        }
        this.props.get_cash_teller_nowmonthly(data);
        this.props.get_list(data);
    }

    Reset() {
        var data = {
            section: 0,
            date: 0,
        }
        this.props.get_list(data);

        this.setState({
            in: 0,
            out: 0
        });
    }

    In(e: any) {
        this.setState({
            in: e,
        });
    }

    Out(e: any) {
        var i = this.state.out + e;
        this.setState({
            out: this.state.out + e,
        });
    }

    render() {

        return (
            <div className="row cashteller" >
                <div className="item-outer col-lg-12">
                    <Card >
                        <CardContent >
                            <Header
                                Reset={this.Reset}
                                GetList={this.GetList}
                                DateSave={this.DateSave}
                                SectionSave={this.SectionSave}
                                section={this.props.user_details.amSectionId} />
                        </CardContent >
                    </Card >
                </div>

                <div className="item-outer col-lg-12">
                    <Card >
                        <CardContent >
                            {<Grid
                                SelectSection={this.state.SelectSection}
                                section={this.props.user_details.amSectionId}
                                In={this.In}
                                Out={this.Out}
                                GetList={this.GetList}
                                cash_tellers_list={this.props.cash_tellers_list} refresh={this.refresh} />}

                            {(() => {
                                if (this.props.cash_teller_nowmonthly[0]) {
                                    return "";
                                } else {
                                    return <Insert
                                        GetList={this.GetList}
                                        selectedDate={this.state.selectedDate}
                                        user_id={this.props.user_details.id}
                                        section_id={this.state.SelectSection}
                                        cash_tellers_contentslist={this.props.cash_tellers_contentslist} />
                                }
                            })()}

                        </CardContent >

                    </Card >
                </div>

                <div className="item-outer col-lg-12 no_print">
                    <Card >
                        <CardContent >
                            <Footer
                                user_id={this.props.user_details.id}
                                SelectSection={this.state.SelectSection}
                                selectedDate={this.state.selectedDate}
                                section={this.props.user_details.amSectionId}
                                GetList={this.GetList}
                                cash_tellers_list={this.props.cash_tellers_list}
                                in={this.state.in}
                                out={this.state.out} />
                        </CardContent >
                    </Card >
                </div>

            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        user_details: state.masterReducer.user_details,
        cash_tellers_list: state.CashTeller.cash_tellers_list,
        cash_tellers_contentslist: state.CashTeller.cash_tellers_contentslist,
        cash_teller_nowmonthly: state.CashTeller.cash_teller_nowmonthly,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_contentslist(state: any) {
            dispatch(CashTeller.get_cash_tellers_contentslist(state))
        },
        get_list(state: any) {
            dispatch(CashTeller.get_cash_tellers_list(state))
        },
        get_cash_teller_nowmonthly(state: any) {
            dispatch(CashTeller.get_cash_teller_nowmonthly(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




